import { 
  GET_TASK_PRIORITY,
  GET_TASK_PRIORITY_SUCCESS,
  GET_TASK_PRIORITY_ERROR,

  GET_TASK_PRIORITY_LIST,
  GET_TASK_PRIORITY_LIST_SUCCESS,
  GET_TASK_PRIORITY_LIST_ERROR,
  
  CREATE_TASK_PRIORITY,
  CREATE_TASK_PRIORITY_SUCCESS,
  CREATE_TASK_PRIORITY_ERROR, 

  UPDATE_TASK_PRIORITY,
  UPDATE_TASK_PRIORITY_SUCCESS,
  UPDATE_TASK_PRIORITY_ERROR,

  DELETE_TASK_PRIORITY,
  DELETE_TASK_PRIORITY_SUCCESS,
  DELETE_TASK_PRIORITY_ERROR,
} from "./actionTypes"
  
  const initialState = {
    GET_TASK_PRIORITY_SUCCESS: "",
    GET_TASK_PRIORITY_ERROR: "",
    GET_TASK_PRIORITY_LIST_SUCCESS: "",
    GET_TASK_PRIORITY_LIST_ERROR: "",
    CREATE_TASK_PRIORITY_SUCCESS: "",
    CREATE_TASK_PRIORITY_ERROR: "",
    UPDATE_TASK_PRIORITY: "",
    UPDATE_TASK_PRIORITY_SUCCESS: "",
    UPDATE_TASK_PRIORITY_ERROR: "",
    DELETE_TASK_PRIORITY: "",
    DELETE_TASK_PRIORITY_SUCCESS: "",
    DELETE_TASK_PRIORITY_ERROR: "",
    loading: false,
  }
  
  const reducer = (state = initialState, action: any) => {
    switch (action.type) {
      // ---------------------------------------------GET_TASK_PRIORITY
      case GET_TASK_PRIORITY:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_TASK_PRIORITY_SUCCESS:
        state = {
          ...state,
          GET_TASK_PRIORITY_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_TASK_PRIORITY_ERROR:
        state = { 
          ...state, 
          GET_TASK_PRIORITY_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------GET_TASK_PRIORITY_LIST
      case GET_TASK_PRIORITY_LIST:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_TASK_PRIORITY_LIST_SUCCESS:
        state = {
          ...state,
          GET_TASK_PRIORITY_LIST_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_TASK_PRIORITY_LIST_ERROR:
        state = { 
          ...state, 
          GET_TASK_PRIORITY_LIST_ERROR: action.payload, 
          loading: false 
        }
        break
        
      // ---------------------------------------------CREATE_TASK_PRIORITY
      case CREATE_TASK_PRIORITY:
        state = {
          ...state,
          loading: true,
        }
        break

      case CREATE_TASK_PRIORITY_SUCCESS:
        state = {
          ...state,
          CREATE_TASK_PRIORITY_SUCCESS: action.payload,
          loading: false,
        }
        break

      case CREATE_TASK_PRIORITY_ERROR:
        state = { 
          ...state, 
          CREATE_TASK_PRIORITY_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------UPDATE_TASK_PRIORITY
      case UPDATE_TASK_PRIORITY:
        state = {
          ...state,
          loading: true,
        }
        break

      case UPDATE_TASK_PRIORITY_SUCCESS:
        state = {
          ...state,
          UPDATE_TASK_PRIORITY_SUCCESS: action.payload,
          loading: false,
        }
        break

      case UPDATE_TASK_PRIORITY_ERROR:
        state = { 
          ...state, 
          UPDATE_TASK_PRIORITY_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DELETE_TASK_PRIORITY
      case DELETE_TASK_PRIORITY:
        state = {
          ...state,
          loading: true,
        }
        break

      case DELETE_TASK_PRIORITY_SUCCESS:
        state = {
          ...state,
          DELETE_TASK_PRIORITY_SUCCESS: action.payload,
          loading: false,
        }
        break

      case DELETE_TASK_PRIORITY_ERROR:
        state = { 
          ...state, 
          DELETE_TASK_PRIORITY_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DEFAULT
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default reducer
  